export function getFilterDrawer(filterFormComponents: any,applyConfigiuration : any, resetConfguration:any): any {
  return {
    type: "fgModalDialog",
    name: "Modal Dialog",
    icon: "fa fa-square-o",
    class: "card-default",
    config: true,
    children: [
      {
        type: "fgModalHeader",
        name: "Modal Header",
        icon: "fa fa-square-o",
        config: true,
        children: [
          {
            type: "fgword",
            subtype: "h4",
            cat: "HEADING",
            icon: "fa fa-square-o",
            name: "Heading 4",
            text: "Filters",
            condition: {},
            isCoreConfig: true,
            category: "STATIC",
            uuid: crypto.randomUUID(),
            textAlign: "text-left",
            styles: {},
          },
        ],
        condition: {},
        isCoreConfig: true,
        category: "GENERAL",
        uuid: crypto.randomUUID(),
      },
      {
        type: "fgModalBody",
        name: "Modal Body",
        icon: "fa fa-square-o",
        config: true,
        children: [
          {
            type: "fgcustomcontainer",
            name: "Custom Container",
            icon: "fa fa-square-o",
            class: "card-default",
            header: true,
            heading: " some heading",
            config: true,
            children: filterFormComponents,
            condition: {},
            isCoreConfig: true,
            category: "LAYOUT",
            uuid: crypto.randomUUID(),
            parentContainer: true,
            displayContainer: "FORM_CONTAINER",
            styles: {},
          },
        ],
        condition: {},
        isCoreConfig: true,
        category: "GENERAL",
        uuid:crypto.randomUUID(),
        styles: {},
      },
      {
        type: "fgModalFooter",
        name: "Modal Footer",
        icon: "fa fa-square-o",
        config: true,
        children: [
          {
            type: "fgbuttonaction",
            subtype: "formaction",
            icon: "fa fa-plus",
            name: "Form Button",
            condition: {},
            isCoreConfig: true,
            category: "ACTIONS",
            uuid:crypto.randomUUID(),
            actionPurposeCode: "authorise",
            setValueConfig: {
              mappingField: "STATUS",
            },
            messageConfigs: "aftereSubmitMessage",
            messageConfig: {},
            afterMessageConfigs: {},
            option: {
              page: {},
            },
            customReqFieldConfig: {},
            styles: {},
            label: "Reset",
            dynamicLabel: false,
            actionCode: "SetValue",
            closePopupAfterApply: true,
            isSetValueMultipleEnabled: true,
            setValueMappings: resetConfguration,
            buttonClass: "ml-2",
          },
          {
            type: "fgbuttonaction",
            subtype: "formaction",
            icon: "fa fa-plus",
            name: "Form Button",
            condition: {},
            isCoreConfig: true,
            category: "ACTIONS",
            uuid: crypto.randomUUID(),
            actionPurposeCode: "authorise",
            setValueConfig: {
              isSetValueDynamic: true,
              mappingField: "STATUS",
              valueToSet: "STATUS_FILTER",
            },
            messageConfigs: "aftereSubmitMessage",
            messageConfig: {},
            afterMessageConfigs: {},
            option: {
              page: {},
            },
            customReqFieldConfig: {},
            styles: {},
            label: "Apply",
            dynamicLabel: false,
            actionCode: "SetValue",
            isSetValueMultipleEnabled: true,
            closePopupAfterApply: true,
            setValueMappings: applyConfigiuration,
            buttonClass: "ml-2",
          },
        ],
        condition: {},
        isCoreConfig: true,
        category: "GENERAL",
        uuid: crypto.randomUUID(),
        styles: {},
        customClass: "text-right",
      },
    ],
    condition: {},
    isCoreConfig: true,
    category: "GENERAL",
    uuid:crypto.randomUUID(),
    toBeClearFields: [],
    styles: {},
    showAsDrawer: true,
    closeDrawerOnRedirection: true,
    sidenavPosition: "end",
    sidenavMode: "side",
    modelId: "FG_FILTER",
    showCloseBtn: true,
    showAsBottomSheet: false,
  };
}
